// test2705
(2705 && 0);
